import { render, staticRenderFns } from "./ContactoDeudor.vue?vue&type=template&id=acb0d2aa&"
import script from "./ContactoDeudor.vue?vue&type=script&lang=js&"
export * from "./ContactoDeudor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports